import lang from 'LANG';
import { timeResolve } from '@/common/js/date';
import { ESeriesCategory, IPlan, ISubscription } from '@reolink-cloud/interface';
import { getPlanDataSizeStr, isUnlimitedStoragePlan } from '@/utils/business';
import { formatTime } from '@/utils/time';

// 套餐名称格式--套餐名（周期）
export function planName( plan: IPlan & { planTitle?: string;title?: string; }): string {

    if ( !plan ) {

        return '';

    }
    //For legacy page
    if ( 'cycle' in plan && !( 'duration' in plan )) {

        return `${plan.planTitle ?? plan.title ?? ''}
        (${lang.tc( `cycle.${plan.cycle.interval.unit}`, plan.cycle.interval.frequency, {
        count: plan.cycle.interval.frequency
    })})`;

    }

    let planName =  `${plan.planTitle ?? plan.title ?? plan.series?.i18n.name ?? ''}`;

    if ( plan.series?.category !== ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN ) {

        planName += `(${lang.tc( `cycle.${plan.duration.unit}`, plan.duration.amount, {
            count: plan.duration.amount
        })})`;

    }

    return planName;

}

// 套餐存储历史天数文案
export function planHistory( plan: IPlan ): string {

    return lang.t( 'plan.history', {
        history: plan.style['cloud_storage.video_lifetime']
    }) as string;

}

// 套餐支持设备数量文案
export function planCamera( plan: IPlan ): string {

    return lang.tc( 'plan.camera', plan.style['cloud_storage.max_device_quantity'], {
        count: plan.style['cloud_storage.max_device_quantity']
    });

}

// 套餐流量
export function planFlow( plan: IPlan ): string {

    return getPlanDataSizeStr( plan, lang ) ;

}

// 套餐存储空间文案
export function planCapacity( plan: IPlan ): string {

    const GB = 1024 * 1024 * 1024;
    const storageInGB = lang.n( Number((( plan.style['cloud_storage.space_capacity'] ?? 0 ) / GB ).toFixed( 2 )));

    return lang.t( 'plan.storage', {
        storage: isUnlimitedStoragePlan( plan ) ? lang.tc( 'plan.unlimited' ) + ' ' : storageInGB
    }) as string;

}
export function planRichNotification( plan: IPlan ): string {

    const dailyLimit = plan.style['rich_notification.daily_limit'];
    // 0 / 缺省视为无限；>0 为每日张数上限
    if ( typeof dailyLimit === 'number' && dailyLimit > 0 ) {

        return lang.t( 'plan.richNotificationLimit', { limit: dailyLimit }) as string;

    }

    if ( plan.style['cloud_storage.rich_notification'] === 'static_and_dynamic_image' ) {

        return lang.t( 'plan.richNotificationGif' ) as string;

    }

    if (
        plan.style['cloud_storage.allow_rich_notification']
        || plan.style['cloud_storage.rich_notification'] === 'static_image'
        || plan.style['cloud_storage.rich_notification'] === 'static_image_only'
    ) {

        return lang.t( 'plan.richNotificationStatic' ) as string;

    }

    return '';

}

export function timeFormatTraffic( time: string ): string {

    const timeNumber = parseInt( time );
    const {

        year,
        month,
        dateOfMonth,
        hour,
        minute,
        second

    } = timeResolve( timeNumber );

    return `${( lang.t( 'date_format.default', {

        day: dateOfMonth,
        year,
        month

    }) as string )} ${hour}:${minute}:${second}`;

}

export function timeFormat( time: number ): string {

    const {

        year,
        month,
        dateOfMonth,
        hour

    } = timeResolve( time );

    return `${( lang.t( 'date_format.default', {

        day: dateOfMonth,
        year,
        month

    }) as string )} ${hour}:00`;

}

// 套餐有效期文案格式
export function planValidTime( sub: ISubscription ): string {

    const { status } = sub;

    if ( status === 'active' ) {

        const endingAt = sub.endingAt;

        return formatTime( endingAt, lang.t.bind( lang ), '12' );

    } else if ( sub.expiredAt === 0 ) {

        return lang.tc( 'dashboard.status.inactive' );

    } else {

        return lang.tc( 'dashboard.status.expired' );

    }

}

export function toFixed2( num: string ): string {

    return ( Math.round( Number( num ) * 100 ) / 100 ).toFixed( 2 );

}

// 套餐有效期文案格式
export function trafficValidTime( sub: any ): string {

    const { status, reason } = sub;
    if ( status === 'active' ) {

        const expiringAt = sub.expiringAt;
        return lang.tc( 'dashboard.package_card.valid_till' ) + ' ' + timeFormatTraffic( expiringAt );

    } else if ( sub.expiringAt === 0 ) {

        return lang.tc( 'dashboard.status.inactive' );

    } else {

        return lang.tc( 'dashboard.package_card.status' ) + ': ' + lang.tc( `dashboard.package_card.reason.${reason}` );

    }

}

export function desensitizeString( input: string|undefined ): string {

    if ( typeof input !== 'string' ) {

        return '';

    }

    const length = input.length;

    // 如果字符串长度小于等于 2，直接返回原字符串
    if ( length <= 2 ) {

        return input;

    }

    const startLength = Math.ceil( length * 0.3 ); // 取前30%的字符
    const endLength = Math.ceil( length * 0.2 );   // 取后20%的字符

    const start = input.slice( 0, startLength );
    const end = input.slice( -endLength );

    const maskedLength = length - startLength - endLength;
    const masked = '*'.repeat( maskedLength );

    return `${start}${masked}${end}`;

}
